//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:['query']
}
